import React, { useState, useEffect } from 'react'
import Slider from 'react-slick'
import { withRouter } from 'react-router-dom'

import { getHomeBanners } from 'api/home'
import { useMobile } from 'utils/mobile'

import Banner1MobileFallback from 'assets/img/banner1_mobile_fallback.jpg'
import Banner2MobileFallback from 'assets/img/banner2_mobile_fallback.jpg'

import Banner1WebFallBack from 'assets/img/banner1_web_fallback.jpg'
import Banner2WebFallBack from 'assets/img/banner2_web_fallback.jpg'

import CarouselNext from 'assets/img/carousel_next.png'
import CarouselPrev from 'assets/img/carousel_prev.png'

import Image from '../Image'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import './MainBanners.scss'

const Link = withRouter(({ to, history, children }) => {
    const [swap, setSwap] = useState(false)
    const [clicked, setClicked] = useState(false)

    return (
        <div
            onMouseMove={() => {
                if (clicked) setSwap(true)
            }}
            onMouseDown={() => setClicked(true)}
            onClick={() => {
                setClicked(false)
                setSwap(false)
            }}
            onMouseUp={() => {
                if (!swap) {
                    history.push(to)
                }
            }}
            className="banner-link"
        >
            {children}
        </div>
    )
})

const PrevArrow = ({ className, style, onClick }) => (
    <img
        className={className}
        style={style}
        onClick={onClick}
        src={CarouselPrev}
        alt="Banner anterior"
    />
)

const NextArrow = ({ className, style, onClick }) => (
    <img
        className={className}
        style={style}
        onClick={onClick}
        src={CarouselNext}
        alt="Banner seguinte"
    />
)

const MainBanners = ({ bank, carousel }) => {
    const [banners, setBanners] = useState([])
    const [error, setError] = useState(false)
    const mobile = useMobile()

    const path = bank ? `${bank}/` : ''

    const assets = {
        mobile: {
            src1: `https://www.alelo.com.br/content/dam/ecommerce/banners/${path}Banner1_mob.jpg`,
            src2: `https://www.alelo.com.br/content/dam/ecommerce/banners/Banner2_mob.jpg`,
            errorSrc1: Banner1MobileFallback,
            errorSrc2: Banner2MobileFallback
        },
        desktop: {
            src1: `https://www.alelo.com.br/content/dam/ecommerce/banners/${path}Banner1_desk.jpg`,
            src2: `https://www.alelo.com.br/content/dam/ecommerce/banners/Banner2_desk.jpg`,
            errorSrc1: Banner1WebFallBack,
            errorSrc2: Banner2WebFallBack
        }
    }

    const imageKind = mobile ? 'mobile' : 'desktop'

    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />
    }

    useEffect(() => {
        if (!bank && carousel) {
            getHomeBanners()
                .then((resp) => {
                    setBanners(resp.data.banners)
                })
                .catch(() => {
                    setError(true)
                })
        }
    }, [bank])

    return (
        <div className="main-banners">
            {!bank && carousel && banners.length > 0 && (
                <Slider {...settings}>
                    {banners.map((banner) => {
                        const image = (
                            <img
                                src={banner.banner[imageKind]}
                                alt="banner principal"
                            />
                        )

                        if (banner.path) {
                            return (
                                <Link
                                    key={banner.path}
                                    to={`/destaque/${banner.path}`}
                                >
                                    {image}
                                </Link>
                            )
                        }

                        return <div key={banner}>{image}</div>
                    })}
                </Slider>
            )}
            {(bank || !carousel) && (
                <Image
                    className="main-banners__first"
                    src={assets[imageKind].src1}
                    errorSrc={assets[imageKind].errorSrc1}
                    alt="Banner principal"
                />
            )}
            {error && !bank && (
                <Image
                    className="main-banners__first"
                    src={assets[imageKind].errorSrc1}
                    errorSrc={assets[imageKind].errorSrc1}
                    alt="Banner principal backup"
                />
            )}
            <Image
                className="main-banners__second"
                src={assets[imageKind].src2}
                errorSrc={assets[imageKind].errorSrc2}
                alt="Banner secundário"
            />
        </div>
    )
}

export default MainBanners
